import { Routes } from '@angular/router';
import { AuthGuard } from 'guards';
import { UserClaimTypeExtended } from 'models';
import { AppNotFoundComponent } from './components/app-not-found/app-not-found.component';
import { AppEntryComponent } from './components/app-entry/app-entry.component';
import { AppMaintenanceComponent } from './components/app-maintenance/app-maintenance.component';

export const AppRoutes: Routes = [
	{
		path: '',
		component: AppEntryComponent,
	},
	{
		path: 'admin',
		loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
		canLoad: [AuthGuard],
		canActivate: [AuthGuard],
		data: {
			allowedClaims: <UserClaimTypeExtended[]>['Admin'],
		},
	},
	{
		path: 'guest',
		loadChildren: () => import('./dashboards/guest/guest.module').then(m => m.GuestModule),
		canLoad: [AuthGuard],
		canActivate: [AuthGuard],
		data: {
			allowedClaims: <UserClaimTypeExtended[]>['Guest', 'Host', 'NonMember'],
		},
	},
	{
		path: 'host',
		loadChildren: () => import('./dashboards/host/host.module').then(m => m.HostModule),
		canLoad: [AuthGuard],
		canActivate: [AuthGuard],
		data: {
			allowedClaims: <UserClaimTypeExtended[]>['Host'],
		},
	},
	{
		path: 'platform',
		loadChildren: () => import('./dashboards/platform/platform.module').then(m => m.PlatformModule),
		canLoad: [AuthGuard],
		canActivate: [AuthGuard],
		data: {
			allowedClaims: <UserClaimTypeExtended[]>['Platform'],
		},
	},
	{
		path: 'auth',
		loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule),
	},
	{
		path: 'widgets',
		loadChildren: () => import('./widgets/widgets.module').then(m => m.WidgetsModule),
	},
	{
		path: 'app',
		loadChildren: () => import('./authenticated/authenticated.module').then(m => m.AuthenticatedModule),
		canLoad: [AuthGuard],
		canActivate: [AuthGuard],
		data: {
			allowedClaims: <UserClaimTypeExtended[]>['Host', 'Guest', 'Platform', 'NonMember'],
		},
	},
	{
		path: 'under-maintenance',
		component: AppMaintenanceComponent,
	},
	{
		path: '**',
		component: AppNotFoundComponent,
	},
];
